// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nfblekrijwuomdzxypfi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5mYmxla3Jpand1b21kenh5cGZpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxMTY1NTIsImV4cCI6MjA1NzY5MjU1Mn0.0MCRshDDI4rFF15TmMObdy7JP0EMHPfLZbfpwmbsBok";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);